import { Chip } from "@mui/material";
import CartItemEdit from "../../../../views/ogd/myworkspace/Cart/CartEdit/CartItemEdit";

export const BatchAdmissionRegisterTableHeader = [
  { field: "sl_no", headerName: "SL No", width: 60 },
  { field: "studentName", headerName: "Name", minWidth: 250 },
  { field: "batchName", headerName: "Batch Name", minWidth: 250 },
  { field: "batch_assigned_on", headerName: "Batch Assigned On", minWidth: 200 },
  { field: "studentRegion", headerName: "Region", minWidth: 100 },
  { field: "admissionNo", headerName: "Admission Number", minWidth: 150 },
  { field: "class", headerName: "Class", minWidth: 100 },
  { field: "courseName", headerName: "Course Name", minWidth: 250 },
  { field: "phoneNumber", headerName: "Mobile No", minWidth: 150 },
  { field: "ogaName", headerName: "OGA Name", minWidth: 200 },
  { field: "croName", headerName: "CRO Name", minWidth: 200 },
  {
    field: "certificate",
    headerName: "Certificate Status",
    minWidth: 150,
    // valueGetter: (params) => {
    //   if (params.row.certificate === 0) return "Not Issued";
    //   if (params.row.certificate === 1) return "Issued";
    //   if (params.row.certificate === 2) return "Not Applicable";
    //   return "";
    // },
    renderCell: (params) => {
      const value = params.row.certificate;
      const label =
        value == 0 ? "Not Issued" : value == 1 ? "Issued" : "Not Applicable";
      return (
        <Chip
          sx={{ minWidth: 100 }}
          label={label}
          color={"info"}
          variant="outlined"
          size="small"
        />
      );
    },
  },
  // {
  //   field: "inactiveTimestamp",
  //   headerName: "Student Status",
  //   minWidth: 150,
  //   renderCell: (params) => {
  //     const isInactive = Boolean(params.row.inactiveTimestamp);
  //     return (
  //       <Chip
  //         sx={{ minWidth: 100 }}
  //         label={isInactive ? "Inactive" : "Active"}
  //         color={isInactive ? "error" : "success"}
  //         variant="outlined"
  //         size="small"
  //       />
  //     );
  //   },
  // },
  { field: "cro_lead_status_name", headerName: "Lead Status", minWidth: 200 },
  {
            field: "cart_edit",
            headerName: "Cart Edit",
            width: 100,
            renderCell: (params) => <CartItemEdit row={params.row} />,
          },
];
